  import { Component, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { DashboardComponent } from './layouts/dashboard/dashboard.component';
import { DataService } from './auth/services/data.service';
import { AuthService } from './auth/services/auth.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { SessionService } from './auth/services/session.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    MatProgressSpinnerModule,
    CommonModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'CLMS';
  processing: boolean = false;
  processingTrackReport: boolean = false;
  constructor(
    private dataServ: DataService,
    private authServ: AuthService,
    private sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.authServ.setUserCredentials();

    this.authServ.setDeviceCredentials();

    // this.dataServ.heartBeatInit.subscribe((res: boolean) => {
    //   if (res == true) this.sessionService.startHeartBeat();
    //   else if (res == false) this.sessionService.stopHeartBeat();
    // });
  }

  ngAfterViewInit(): void {
    this.dataServ.processing.subscribe((data: boolean) => {
      setTimeout(() => {
        this.processing = data;
      },0);
    });
    this.dataServ.processingTrackReport.subscribe((data: boolean) => {
      setTimeout(() => {
        this.processingTrackReport = data;
      }, 0);
    });
 
  }





// 4.9 Improper Session Management 

  // @HostListener('window:beforeunload', ['$event'])
  // beforeUnloadHander() {
  //   console.log("window.location.reload()",window.location.reload())
  //   this.PostCall();
  //   return false;
  // }

  // PostCall() {
  //   this.authServ.logOut();
  // }
 
}
